import React, { Component, Suspense } from "react";
import Map from "./editor-components/editor-map";
import classNames from "classnames";
import moment from "moment";
import formatcoords from "formatcoords";
import { Redirect } from "react-router-dom";
import store from "store";
import EditorSidebar from "./editor-components/editor-sidebar";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import { getStyleSettingsByStyleId } from "../utils/utils";

class EditorComponent extends Component {
  static whyDidYouRender = true;

  constructor(props) {
    super(props);
    this._map = React.createRef();

    const { t } = props;
    var initialPlace = {
      city: t("Київ"),
      description: t("Київ"),
      country: t("Україна"),
      latitude: 50.45466,
      longitude: 30.5238,
    };

    var initialDate = new Date();
    initialDate.setHours(0);
    initialDate.setMinutes(0);
    initialDate.setSeconds(0);
      initialDate.setMilliseconds(0);

      //todo: respect DST
      var initialUtcDate = new Date(initialDate.getTime() + (-120) * 60000);

    let style = "simple_white";
    let size = {
      selectedSizeId: "30х40 см",
      ratio: "3-4",
      printWidth: 300,
      printHeight: 400,
    };
    let isTest = false;

    const queryParams = queryString.parse(props.location.search);
    if (queryParams) {
      if (queryParams.style) {
        style = queryParams.style;
      }
      if (queryParams.size) {
        console.log("size:", queryParams.size);
        switch (queryParams.size) {
          case "30":
            size = {
              selectedSizeId: "30х40 см",
              ratio: "3-4",
              printWidth: 300,
              printHeight: 400,
            };
            break;
          case "40":
            size = {
              selectedSizeId: "40х50 см",
              ratio: "4-5",
              printWidth: 400,
              printHeight: 500,
            };
            break;
          case "50":
            size = {
              selectedSizeId: "50х70 см",
              ratio: "5-7",
              printWidth: 500,
              printHeight: 700,
            };
            break;
          case "70":
            size = {
              selectedSizeId: "70х100 см",
              ratio: "7-10",
              printWidth: 700,
              printHeight: 1000,
            };
            break;
        }
      }
      if (queryParams.isTest) {
        if (queryParams.isTest.toLowerCase() === "true") {
          isTest = true;
        }
      }
    }
    var text2 = this.getText2(initialPlace, initialDate, false);
    var state = {
      redirect: null,
      isSmallScreen: true,
      isTest: isTest,

      map: {
        background: "#000000",
        stroke: "#ffffff",
        features: [
          {
            id: "isConstellationsEnabled",
            name: t("Сузір'я"),
            isEnabled: true,
          },
          {
            id: "isGridEnabled",
            name: t("Сітка"),
            isEnabled: false,
          },

          {
            id: "isMWEnabled",
            name: t("Чумацький шлях"),
            isEnabled: false,
          },

          {
            id: "isNamesEnabled",
            name: t("Назви сузір'їв"),
            isEnabled: false,
          },
        ],
      },
      place: initialPlace,
        localDate: initialDate,
        utcDate: initialUtcDate,
      isTimePicked: false,
      //text1: "Наш особливий день\n♡",
      text1: t("Зорі, під якими\nпочалася наша історія\n❤️"),
      //text1: "Зоряне небо в цей день\n♡",
      text2: text2,
      text2BeforeManualEdit: text2,
      price: 0,
      selectedMaterialId: "Бумага",
      selectedHangerId: "Нет",
      selectedMaterialName: "Папір",
      selectedHangerName: "Немає",
      selectedStyleId: style,
      ...size,
    };

    try {
      var editorStateDateString = store.get("editorStateDate");
      if (editorStateDateString) {
        var editorStateDate = new Date(editorStateDateString);
        //addDays(1)
        editorStateDate.setDate(editorStateDate.getDate() + 1);
        if (new Date() < editorStateDate) {
          console.log("restoring state...");
          var restoredState = store.get("editorState");
          if (restoredState) {
            restoredState.date = new Date(restoredState.date);

            state = { ...state, ...restoredState };
            console.log("state restored");
          }
        }
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }

    state.initialSelectedMaterialId = state.selectedMaterialId;
    state.initialSelectedSizeId = state.selectedSizeId;
    state.initialSelectedHangerId = state.selectedHangerId;
    this.state = state;
    //console.log(this.state);
  }




  componentDidMount() {
    try {
      var host = window.location.hostname;
      if (!host.startsWith("localhost")) {
        window.fbq("trackSingle", "532340200777420", "Lead", {
          content_name: "Editor",
        });

        window.gtag("event", "lead", {
          send_to: "UA-119404542-2",
          event_category: "main",
        });
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  onText1Changed = (event) => {
    try {
      this.setState({ text1: event.target.value });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onText1Selected = (text) => {
    try {
      this.setState({ text1: text });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onText2Changed = (event) => {
    try {
      this.setState({ text2: event.target.value });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onPlaceChanged = (place) => {
    try {
      this.updatePlaceAndText2(place);

      if (place && place.city) {
        var host = window.location.hostname;
        if (!host.startsWith("localhost")) {
          window.gtag("event", "search", {
            send_to: "UA-119404542-2",
            event_category: "main",
            event_label: place.city,
          });
          window.fbq("trackSingle", "532340200777420", "Search", {
            search_string: place.city,
          });
        }
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onDateChanged = (localDate, utcDate, isTimePicked) => {
    try {
      var local = localDate.toDate();
        console.log("local date:", local);
        var utc = utcDate.toDate();
        console.log("utc date:", utc);
        this.updateDateAndText2(local, utc, isTimePicked);
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  getText2(place, date, isTimePicked) {
    try {
      const { city, country, latitude, longitude } = place;
      var momentDate = new moment(date);
      return (
        city +
        ", " +
        country +
        "\n" +
        (isTimePicked
          ? momentDate.format("DD.MM.YYYY HH:mm")
          : momentDate.format("DD.MM.YYYY")) +
        "\n" +
        //"DDMMssX"
        formatcoords(latitude, longitude).format("D°M's\"X", {
          latLonSeparator: " ",
          decimalPlaces: 2,
        })
      );
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  updateDateAndText2(localDate, utcDate, isTimePicked) {
      var text2 = this.getText2(this.state.place, localDate, isTimePicked);
      this.setState({ utcDate: utcDate, localDate: localDate, text2, isTimePicked, text2BeforeManualEdit: text2 });
  }

  updatePlaceAndText2(place) {
      var text2 = this.getText2(place, this.state.localDate, this.state.isTimePicked);
    this.setState({ place, text2, text2BeforeManualEdit: text2 });
  }

  onFeatureChanged = (event, featureId) => {
    const target = event.target;
    const value = target.checked;

    this.setState((prevState) => ({
      map: {
        ...prevState.map,
        features: prevState.map.features.map((el) =>
          el.id === featureId ? { ...el, isEnabled: value } : el
        ),
      },
    }));
  };

  onStyleChanged = (e, styleId) => {
    const target = e.target;
    const value = target.checked;
    if (value) {
      this.applyStyle(styleId);
    }
  };

  applyStyle(styleId) {
    let styleSettings = getStyleSettingsByStyleId(styleId);

    this.setState((prevState) => ({
      map: {
        ...prevState.map,
        ...styleSettings,
      },
      selectedStyleId: styleId,
    }));
  }

  onMaterialChanged = (info) => {
    const {
      price,
      ratio,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      width: printWidth,
      height: printHeight,
    } = info;
    this.setState({
      price,
      ratio,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      printWidth,
      printHeight,
    });
  };

  onMakeOrderClick = (materialUpdateInfo) => {
    var state = null;
    if (materialUpdateInfo) {
      state = { ...this.state, ...materialUpdateInfo };
    } else {
      state = { ...this.state };
    }
    store.set("editorStateDate", new Date());
    store.set("editorState", state);

    const {
        utcDate,
      text1,
      text2,
      text2BeforeManualEdit,
      price,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      selectedStyleId,
      place,
      map,
      printWidth,
      printHeight,
    } = state;

    const {
      width: mapWidth,
      height: mapHeight,
      containerWidth,
      containerHeight,
    } = this._map.current.getMapSize();

    const isNamesEnabled = map.features.find((f) => f.id === "isNamesEnabled");
    const convertedMap = {
      mapWidth,
      mapHeight,
      containerWidth,
      containerHeight,
      background: map.background,
      stroke: map.stroke,
      isGridEnabled: map.features.find((f) => f.id === "isGridEnabled")
        .isEnabled,
      isConstellationsEnabled: map.features.find(
        (f) => f.id === "isConstellationsEnabled"
      ).isEnabled,
      isMWEnabled: map.features.find((f) => f.id === "isMWEnabled").isEnabled,
      isNamesEnabled: isNamesEnabled ? isNamesEnabled.isEnabled : false,
      language: i18n.language,
    };

    const convertedDescription = {
      material: selectedMaterialName,
      size: selectedSizeId,
      hanger: selectedHangerName,
      style: selectedStyleId,
    };

    const product = {
        productType: "sky",
        date: utcDate,
      text1,
      text2,
      text2BeforeManualEdit,
      price,
      material: selectedMaterialId,
      size: selectedSizeId,
      hanger: selectedHangerId,
      style: selectedStyleId,
      printWidth,
      printHeight,
      place: (({ latitude, longitude, ...rest }) => ({
        centerLat: latitude,
        centerLon: longitude,
        ...rest,
      }))(place),
      map: convertedMap,
      description: convertedDescription,
    };
    store.set("product", product);

    this.setState({ redirect: "cart" });
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            // state: { product },
          }}
        />
      );
    }
    console.log("rendering: editor");
    return (
      <div class="d-flex flex-column-reverse flex-md-row  ">
        <div class="bd-highlight d-flex flex-column flex-md-row">
          <EditorSidebar
            date={this.state.localDate}
            onDateChanged={this.onDateChanged}
            city={this.state.place.description}
            latitude={this.state.place.latitude}
            longitude={this.state.place.longitude}
            onPlaceChanged={this.onPlaceChanged}
            selectedStyleId={this.state.selectedStyleId}
            onStyleChanged={this.onStyleChanged}
            features={this.state.map.features}
            onFeatureChanged={this.onFeatureChanged}
            initialSelectedMaterialId={this.state.initialSelectedMaterialId}
            initialSelectedSizeId={this.state.initialSelectedSizeId}
            initialSelectedHangerId={this.state.initialSelectedHangerId}
            onMaterialChanged={this.onMaterialChanged}
            text1={this.state.text1}
            onText1Changed={this.onText1Changed}
            onText1Selected={this.onText1Selected}
            text2={this.state.text2}
            onText2Changed={this.onText2Changed}
            onMakeOrderClick={this.onMakeOrderClick}
            price={this.state.price}
            isTest={this.state.isTest}
          ></EditorSidebar>
        </div>
        <div class="bd-highlight flex-grow-1">
          <div class="content text-center d-flex justify-content-center">
            <Map
              ref={this._map}
              map={this.state.map}
              latitude={this.state.place.latitude}
                        longitude={this.state.place.longitude}
                        date={this.state.utcDate}
              text1={this.state.text1}
              text2={this.state.text2}
              styleId={this.state.selectedStyleId}
              ratio={this.state.ratio}
              isTest={this.state.isTest}
            ></Map>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(EditorComponent);
